export type InfoScreenDisplayType = 1 | 2;

interface IInfoScreenDisplayTypeEnum {
    Schedule: InfoScreenDisplayType;
    Locations: InfoScreenDisplayType;
    format(value: number): string | undefined;
    displayTypesArray(): any[];
}

const dataSource = () => [
    { key: 1, text: 'Tvarkaraštis' },
    { key: 2, text: 'Lokacijos' }
];

export const infoScreenDisplayType: IInfoScreenDisplayTypeEnum = {
    Schedule: 1,
    Locations: 2,
    format(value: number) {
        const item = dataSource().find(x => x.key === value);
        return item && item.text;
    },
    displayTypesArray() {
        let types: any[] = [];
        dataSource().map(x => {
            types.push(x);
        });
        return types;
    }
};
